<template>
  <div
    class="event-date-list-item"
    :class="{ today: isToday, '--sunday': isSunday }"
    @click.stop="$emit('click')">
    <div class="event-date-list-item__inner">
      <div
        class="event-date-list-item__date"
        :class="{ '--holiday': isHoliday, '--sunday': isSunday, '--saturday': isSaturday }">
        <div class="event-date-list-item__date-day">
          {{ dateNum }}
        </div>
        &nbsp;({{ weekDay | weekDay2Kanji }})
      </div>
      <div class="event-date-list-item__event-list">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import getDay from 'date-fns/getDay'
import getDate from 'date-fns/getDate'
import isToday from 'date-fns/isToday'
import { isHoliday } from '@/utils/holidays'
export default {
  filters: {
    weekDay2Kanji (v) {
      switch (v) {
      case 0:
        return '日'
      case 1:
        return '月'
      case 2:
        return '火'
      case 3:
        return '水'
      case 4:
        return '木'
      case 5:
        return '金'
      case 6:
        return '土'
      default:
        console.error('out of weekdays')
        return null
      }
    }
  },
  props: {
    date: {
      type: Date,
      required: true
    },
  },
  computed: {
    isToday() {
      return isToday(this.date)
    },
    dateNum() {
      return getDate(this.date)
    },
    weekDay() {
      return getDay(this.date)
    },
    isSaturday() {
      return this.weekDay === 6
    },
    isSunday() {
      return this.weekDay === 0
    },
    isHoliday() {
      return isHoliday(this.date)
    }
  },
}
</script>

<style lang="scss" scoped>
.event-date-list-item {
  background-color: #FFFFFF;
  padding: 4px;
  border-bottom: 1px solid $grey03;

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 8px 8px;
  }

  &.--sunday {
    border-bottom: 3px solid $grey03;
  }

  &__event-list {
    flex: 1;
    overflow: hidden;
  }

  &__inner {
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
  }

  &.today {
    background-color: lighten($l-blue, 50%)
  }

  &__date {
    display: flex;
    font-size: 14px;
    font-weight: 700;
    padding-right: 8px;

    &-day {
      width: 28px;
      text-align: center;
    }

    &.--saturday {
      color: $l-blue;
    }
    &.--sunday, &.--holiday {
      color: red;
    }
  }
}
</style>